import { LocationTypesEnum } from '../../../pages/adgroup/settings/geoTargeting/GeoTargetingFields'

export function getGeoLocationChipLabel(
  option: { name?: string | null; label?: string | null; radius?: number | null },
  locationType: LocationTypesEnum
): string {
  if (locationType === LocationTypesEnum.Cities) {
    return `${option.name} - ${option.radius}km`
  }
  return option?.name || option.label || ''
}

export function getGeoLocationOptionLabel(option: unknown, locationType: LocationTypesEnum): string {
  if (typeof option === 'string') return option
  if (Array.isArray(option) || option === null || typeof option !== 'object') return ''

  const placeOption = option as {
    description?: string
    name?: string | null
    label?: string | null
    radius?: number | null
  }
  if (placeOption.description) return placeOption.description

  return getGeoLocationChipLabel(placeOption, locationType)
}
